
import {defineComponent, PropType, ref} from "vue";
import {
  IDefGuideBase,
  IDefinition,
  IEvidenceMap,
  IGuideline,
  IProt,
  IRct,
  ISr,
  IStudy
} from "@/interfaces/evidence-map";
import ShareButtons from "@/components/ShareButtons.vue";
import {useMapStore} from "@/mixins/mapStore";

export default defineComponent({
  name: "DataViewer",
  components: {ShareButtons},
  props: {
    rct: {
      type: Object as PropType<IRct>
    },
    sr: {
      type: Object as PropType<ISr>
    },
    prot: {
      type: Object as PropType<IProt>
    },
    def: {
      type: Object as PropType<IDefinition>
    },
    guide: {
      type: Object as PropType<IGuideline>
    },
    map: {
      type: Object as PropType<IEvidenceMap>
    }
  },
  setup(props) {
    const mapStore = useMapStore()
    const study = ref<IStudy | null>(null)
    const defGuide = ref<IDefGuideBase>(null)
    if (props.rct) {
      study.value = Object.assign(props.rct);
    } else if (props.sr) {
      study.value = Object.assign(props.sr);
    } else if (props.def) {
      defGuide.value = Object.assign(props.def)
    } else if (props.guide) {
      defGuide.value = Object.assign(props.guide)
    }

    const copied = ref<string>("")

    const copyCiteToClipboard = () => {
      const l_Cite = props.map ? props.map.citation :study.value ?
          `${study.value.firstAuthor} et al. ${study.value.title}. ${study.value.journal}. ${study.value.year}; ${study.value.volume}.` :
          `${defGuide.value.firstAuthor} et al. ${defGuide.value.titleShown}. ${defGuide.value.journal}. ${defGuide.value.year}; ${defGuide.value.volume}.`
      navigator.clipboard.writeText(l_Cite).then(function () {
        copied.value = "copied!"
        setTimeout(() => {
          copied.value = ""
        }, 1000)
      }, function (err) {
        console.error('Async: Could not copy text: ', err);
      });
    }
    return {
      copyCiteToClipboard,
      copied,
      study,
      defGuide,
      mapStore,
    }


  }
})
